import { ShieldX } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'

export const AccessDeniedPage = () => (
	<div className='flex min-h-[60vh] flex-col items-center justify-center text-center'>
	<div className='rounded-full bg-red-50 p-4 text-red-600'><ShieldX className='h-8 w-8' /></div>
	<h1 className='mt-5 text-2xl font-semibold sm:text-3xl'>Недостаточно прав</h1>
	<p className='mt-2 max-w-md text-sm leading-6 text-muted-foreground'>
		Текущая роль не разрешает требуемую административную операцию. Решение принимается по policy matrix из BFF-контракта.
	</p>
	<Button asChild variant='outline' className='mt-5'><Link to='/'>На главную</Link></Button>
	</div>
)
